<div class="join-lomy">
  <!-- LOMY header markup replicated locally to avoid module scope issues -->
  <div class="join-lomy-header">
    <img src="assets/images/logo-login.png" />

    <h2>
      Potvrda kupona <app-lomy-logo></app-lomy-logo>
    </h2>
    <p class="join-lomy-header__subtitle">
      Upute za vlasnike i djelatnike: kako potvrditi kupon koji vam kupac pokaže na
      blagajni, i što napraviti s kuponima koji se iskorištavaju kod dostave.
    </p>
  </div>

  <div class="form-application__wrapper">
    <div class="manual-cards">
      <div
        class="manual-cards__card manual-cards__card--{{ themes[idx % themes.length] }}"
        *ngFor="let s of sections; let idx = index"
      >
        <div class="card__icon">
          <div class="card__icon--inner"></div>
        </div>
        <!-- Screenshots / Carousel per card -->
        <div
          class="card__media"
          *ngIf="s.images && s.images.length"
          (touchstart)="onTouchStart($event)"
          (touchend)="onTouchEnd($event, idx)"
        >
          <img
            [src]="s.images[currentSlides[idx] || 0]"
            [alt]="s.title + ' screenshot ' + ((currentSlides[idx]||0)+1)"
            draggable="false"
            (click)="openLightbox(idx, currentSlides[idx] || 0)"
          />
          <button
            type="button"
            class="nav nav--prev"
            (click)="prevSlide(idx)"
            aria-label="Previous image"
          >
            ‹
          </button>
          <button
            type="button"
            class="nav nav--next"
            (click)="nextSlide(idx)"
            aria-label="Next image"
          >
            ›
          </button>
          <div class="dots" *ngIf="s.images.length > 1">
            <button
              type="button"
              class="dot"
              *ngFor="let _ of s.images; let i = index"
              [class.active]="(currentSlides[idx] || 0) === i"
              (click)="goToSlide(idx, i)"
              [attr.aria-label]="'Go to image ' + (i+1)"
            ></button>
          </div>
        </div>
        <h4>{{ s.title }}</h4>
        <!-- Dodatni opisni popisi (opcionalno po sekciji) -->
        <div class="manual-lists" *ngIf="s.lists?.length">
          <div class="manual-list" *ngFor="let list of s.lists">
            <h5 class="manual-list__title">{{ list.title }}</h5>
            <ul class="manual-list__items">
              <li *ngFor="let item of list.items">{{ item }}</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Fullscreen Lightbox Overlay -->
<div
  class="lightbox"
  *ngIf="isLightboxOpen && lightboxSectionIndex !== null"
  [ngClass]="'lightbox--' + themes[(lightboxSectionIndex || 0) % themes.length]"
  role="dialog"
  aria-modal="true"
  tabindex="0"
  (keydown)="onLightboxKeydown($event)"
>
  <div class="lightbox__backdrop" (click)="closeLightbox()"></div>
  <div
    class="lightbox__content"
    (touchstart)="onLbTouchStart($event)"
    (touchend)="onLbTouchEnd($event)"
  >
    <button class="lightbox__close" (click)="closeLightbox()" aria-label="Close">✕</button>
    <button class="lightbox__nav lightbox__nav--prev" (click)="prevLightbox()" aria-label="Previous image">‹</button>
    <img
      class="lightbox__image"
      [src]="sections[lightboxSectionIndex].images[lightboxSlideIndex]"
      [alt]="sections[lightboxSectionIndex].title + ' fullscreen ' + (lightboxSlideIndex+1)"
      draggable="false"
    />
    <button class="lightbox__nav lightbox__nav--next" (click)="nextLightbox()" aria-label="Next image">›</button>
    <div class="lightbox__dots" *ngIf="sections[lightboxSectionIndex].images.length > 1">
      <button
        class="dot"
        *ngFor="let _img of sections[lightboxSectionIndex].images; let i = index"
        [class.active]="lightboxSlideIndex === i"
        (click)="goToLightboxSlide(i)"
        [attr.aria-label]="'Go to image ' + (i+1)"
      ></button>
    </div>
  </div>
</div>
